import { Link } from 'react-router-dom'
import { Title, SEO } from '../../components'
import { Header, Footer } from '../../containers/'

const NotFound = () => {
  return (
    <>
      <SEO
        title="Page Not Found | Ajeet Singh Baddan"
        path="/404"
        noindex
      />
      <Header/>
      <Title title='Page Not Found'/>
      <div className='container mx-auto py-10 md:py-20 text-center'>
        <p className='font-manrope md:text-xl theme-blue mb-8'>The page you're looking for doesn't exist or may have moved.</p>
        <Link to="/" className='bg-theme-blue rounded text-white px-4 py-3 inline-block duration-500 hover:theme-light'>Back to Home</Link>
      </div>
      <Footer/>
    </>
  )
}

export default NotFound
